import { render } from "./TextContent.vue?vue&type=template&id=2c685114"
import script from "./TextContent.vue?vue&type=script&lang=js"
export * from "./TextContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__